'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = exports.colors = exports.createBorders = exports.createSpacers = exports.createColours = undefined;
var _contact = require('@marmalade/contact');
var _polished = require('polished');
var _marmaladeLogoWhite = require('../images/marmalade-logo-white.svg');
var _marmaladeLogoWhite2 = _interopRequireDefault(_marmaladeLogoWhite);
var _marmaladeLogoSmallWhite = require('../images/marmalade-logo-small-white.svg');
var _marmaladeLogoSmallWhite2 = _interopRequireDefault(_marmaladeLogoSmallWhite);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var createColours = exports.createColours = function createColours() {
  var baseColors = {
    colorPrimary: '#e9511e',
    colorPrimaryLight: '#fc7f47',
    colorSecondary: '#216061',
    colorSecondaryLight: '#7aa0a0',
    colorDefinition: '#d3dfdf',
    colorWarning: '#f69f13',
    colorDanger: '#ec4242',
    colorDangerLightSolid: '#FBD9D9',
    colorSelected: '#74b85c',
    colorSuccess: '#70b857',
    colorBlack: '#0d0802',
    colorGreyVeryDark: '#262626',
    colorWhite: '#fff',
    colorGreyLight: '#d2d5d7',
    colorGrey: '#5d6770',
    colorOffWhite: '#f9f9f9',
    colorOffWhiteDark: '#f5f5f5',
    colorBlueLight: '#e1e8e9',
    colorGreyDark: '#9ca9b5',
    colorRed: '#ac3b0a'
  };
  return Object.assign({}, baseColors, {
    colorWarningLight: (0, _polished.rgba)(baseColors.colorWarning, 0.2),
    colorWarningDark: (0, _polished.darken)(0.15, baseColors.colorWarning),
    colorDangerLight: (0, _polished.rgba)(baseColors.colorDanger, 0.2),
    colorDangerDark: (0, _polished.darken)(0.15, baseColors.colorDanger),
    colorSuccessLight: (0, _polished.rgba)(baseColors.colorSuccess, 0.2),
    colorSuccessDark: (0, _polished.darken)(0.15, baseColors.colorSuccess),
    colorShadow: (0, _polished.rgba)(baseColors.colorBlack, 0.5),
    colorBase: baseColors.colorBlack
  });
};
var createSpacers = exports.createSpacers = function createSpacers() {
  var space_base = 3;
  return {
    space_xs: space_base / 6 + 'rem',
    space_sm: space_base / 2 + 'rem',
    space_md: space_base + 'rem',
    space_lg: space_base * 2 + 'rem',
    space_xl: space_base * 4 + 'rem'
  };
};
var createBorders = exports.createBorders = function createBorders() {
  var borders = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: colors.colorGreyLight,
    borderRadius: '.3rem'
  };
  return Object.assign({}, borders, {
    border: borders.borderWidth + ' ' + borders.borderStyle + ' ' + borders.borderColor
  });
};
var colors = exports.colors = createColours();
var breakpoints = exports.breakpoints = {
  breakpoint_xs: 600,
  breakpoint_sm: 768,
  breakpoint_md: 992,
  breakpoint_lg: 1200
};
var spacers = createSpacers();
var borders = createBorders();
exports.default = Object.assign({}, colors, borders, {
  openingHours: _contact.constants.openingHours,
  telephone: _contact.constants.phone.products,
  fontBold: 700,
  lineHeight: 1.5,
  fontSize: '1.6rem',
  fontSizeLarger: '1.8rem',
  font: "'Lato', sans-serif",
  base: '10px',
  logo: process.env.REACT_APP_ASSETS_URL + '/shared/assets/img/logos/marmalade_desktop.svg',
  logo_small: process.env.REACT_APP_ASSETS_URL + '/shared/assets/img/logos/marmalade_mobile.svg',
  logo_white: _marmaladeLogoWhite2.default,
  logo_small_white: _marmaladeLogoSmallWhite2.default,
  logo_link: 'https://www.wearemarmalade.co.uk/',
  account_link: '/account/dashboard',
  login_link: '/login',
  A_color: colors.colorPrimary,
  A_textDecoration: 'none',
  A_textDecoration_hover: 'underline',
  Page_backgroundColor: colors.colorWhite,
  Html_backgroundColor: '#eee',
  Footer_poweredBy: false,
  fdiQuickQuote: true,
  pageWidthLimit: 0
}, breakpoints, spacers, {
  name: "Marmalade"
});